import React from 'react';

const AuthorInfo = ({ author, date }) => {
  // Error prevention: handle missing author data
  if (!author) {
    return (
      <div style={styles.container}>
        <div style={styles.authorMeta}>
          <p style={styles.date}>{date || 'Publication date not available'}</p>
        </div>
      </div>
    );
  }
  
  // Extract the author data safely
  const authorName = typeof author === 'object' ? author.name || 'Anonymous' : author;
  const authorTitle = author.title || '';
  const authorAvatar = author.avatar || '';
  
  return (
    <div style={styles.container}>
      <div style={styles.authorInfo}>
        {authorAvatar && (
          <div style={styles.avatar}>
            <img src={authorAvatar} alt={authorName} style={styles.avatarImage} />
          </div>
        )}
        <div style={styles.authorMeta}>
          <h3 style={styles.authorName}>{authorName}</h3>
          {authorTitle && <p style={styles.authorTitle}>{authorTitle}</p>}
          <p style={styles.date}>{date || 'Date not available'}</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    marginBottom: '32px',
    padding: '20px 0',
    borderBottom: '1px solid #e5e7eb',
  },
  authorInfo: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    marginRight: '16px',
    overflow: 'hidden',
  },
  avatarImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  authorMeta: {
    display: 'flex',
    flexDirection: 'column',
  },
  authorName: {
    fontSize: '1rem',
    fontWeight: '600',
    color: '#111827',
    margin: 0,
  },
  authorTitle: {
    fontSize: '0.875rem',
    color: '#6b7280',
    margin: '4px 0 0 0',
  },
  date: {
    fontSize: '0.875rem',
    color: '#6b7280',
    margin: '4px 0 0 0',
  },
};

export default AuthorInfo;